import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Search, X, Loader2 } from "lucide-react";
import { useAuth } from "@/App";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function SucheFeld({ onOpen }) {
  return (
    <button onClick={onOpen} className="h-10 w-10 sm:w-64 rounded-xl border border-slate-200 bg-slate-50 hover:bg-white text-slate-500 text-sm flex items-center justify-center sm:justify-start gap-2 sm:px-3" aria-label="Suche öffnen" data-testid="suche-oeffnen">
      <Search className="h-4 w-4" /><span className="hidden sm:inline flex-1 text-left">Suchen …</span><kbd className="hidden lg:inline text-[10px] text-slate-400 border border-slate-200 rounded px-1">⌘K</kbd>
    </button>
  );
}

export default function CRMSuche({ offen, onClose }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [res, setRes] = useState(null);
  const [laeuft, setLaeuft] = useState(false);
  const [idx, setIdx] = useState(0);
  const ref = useRef(null);
  useEffect(() => { if (offen) { setQ(""); setRes(null); setIdx(0); setTimeout(() => ref.current?.focus(), 30); } }, [offen]);
  useEffect(() => {
    if (!offen || q.trim().length < 2) { setRes(null); return; }
    setLaeuft(true);
    const t = setTimeout(() => axios.get(`${API}/suche`, { params: { q: q.trim() }, headers: { Authorization: `Bearer ${user.token}` } }).then((r) => { setRes(r.data); setIdx(0); }).catch(() => setRes({ gruppen: [], anzahl: 0 })).finally(() => setLaeuft(false)), 220);
    return () => clearTimeout(t);
  }, [q, offen, user.token]);
  if (!offen) return null;
  const flach = (res?.gruppen || []).flatMap((g) => g.items.map((i) => ({ ...i, gruppe: g.label })));
  const go = (item) => { if (!item) return; onClose(); if (item.link.startsWith("/mitarbeiter")) window.location.assign(item.link); else navigate(item.link); };
  const key = (e) => { if (e.key === "Escape") onClose(); if (e.key === "ArrowDown") { e.preventDefault(); setIdx((i) => Math.min(flach.length - 1, i + 1)); } if (e.key === "ArrowUp") { e.preventDefault(); setIdx((i) => Math.max(0, i - 1)); } if (e.key === "Enter") go(flach[idx]); };
  let n = -1;
  return (
    <div className="fixed inset-0 z-[80] bg-black/40 flex items-start justify-center p-3 sm:pt-[10vh]" onClick={onClose} data-testid="suche-dialog">
      <div className="w-full max-w-xl bg-white rounded-2xl shadow-2xl overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2 px-3 h-14 border-b border-slate-200">
          {laeuft ? <Loader2 className="h-5 w-5 text-slate-400 animate-spin" /> : <Search className="h-5 w-5 text-slate-400" />}
          <input ref={ref} value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={key} placeholder="Mitarbeiter, Kunde, Flyertour, Dienstanweisung, Werbeort …" className="flex-1 h-full outline-none text-base" data-testid="suche-eingabe" />
          <button onClick={onClose} className="h-10 w-10 flex items-center justify-center rounded-lg hover:bg-slate-100" aria-label="Schließen" data-testid="suche-schliessen"><X className="h-5 w-5 text-slate-500" /></button>
        </div>
        <div className="max-h-[60vh] overflow-y-auto" data-testid="suche-ergebnisse">
          {q.trim().length < 2 && <p className="px-4 py-5 text-sm text-slate-500">Mindestens zwei Zeichen eingeben. Tipp: ⌘K / Strg+K öffnet die Suche überall im CRM.</p>}
          {res && res.anzahl === 0 && <p className="px-4 py-5 text-sm text-slate-500" data-testid="suche-leer">Nichts gefunden für „{q}“.</p>}
          {res?.gruppen.map((g) => (
            <div key={g.key} className="py-1">
              <p className="px-4 pt-2 pb-1 text-[11px] font-bold uppercase tracking-wider text-slate-400">{g.label}</p>
              {g.items.map((it) => { n += 1; const me = n; return (
                <button key={it.id} onMouseEnter={() => setIdx(me)} onClick={() => go(it)} className={`w-full text-left px-4 py-2 flex flex-col ${idx === me ? "bg-cyan-50" : "hover:bg-slate-50"}`} data-testid={`suche-treffer-${g.key}`}>
                  <span className="text-sm font-semibold text-slate-900">{it.titel}</span><span className="text-xs text-slate-500">{it.sub}</span>
                </button>); })}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
